import { languageMap } from ".."

languageMap.git = {
	comments: {
		line: "#",
	},
}
